<script>
import VClamp from 'vue-clamp';

import { featuredCampaigns } from '../api/crowdpacs';

export default {
  name: 'CpFeaturedCampaigns',
  components: {
    CpButton: require('../button').default,
    CpImage: require('../image').default,
    handleImageError: require('../mixins/utils').default,
    capitalizeFirstLetter: require('../mixins/utils.js').default,
    CpShowImageInCard: require('../components/ShowImageInCard').default,
    VClamp,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginBottom: require('../directives/margins').marginBottom,
    marginLeft: require('../directives/margins').marginLeft,
  },
  mounted() {
    this.getFeaturedCampaigns();
  },
  data() {
    return {
      campaigns: [],
    };
  },
  methods: {
    getFeaturedCampaigns() {
      featuredCampaigns()
        .then(response => {
          this.campaigns = response.featured_campaigns;
        })
        .catch(error => {
          console.warn(error);
        });
    },
    navigateTo(path) {
      window.location.href = path;
    },
    contributionText(count, type) {
      if (count > 1) {
        return `${count} ${this.capitalizeFirstLetter(type)}`
      } else {
        const customType = type.slice(0, -1);
        return `${count} ${this.capitalizeFirstLetter(customType)}`
      }
    },
    endorsementText(count) {
      if (count > 1) {
        return `${count} Endorsements`
      } else {
        return `${count} Endorsement`
      }
    },
  },
};
</script>
<template>
  <div v-if="campaigns && campaigns.length">
    <h3 class="H3 black-color">Featured Campaigns</h3>
    <a v-for="(item, index) in campaigns" :key="item.id" :href="item.permalink" v-margin-left="0.5" class="featuredItemContainer">
      <span class="textContainer" v-margin-bottom="1">
        <p class="caption1 neutral6-color" v-margin-top="0" v-margin-bottom="0.2">
          <VClamp autoresize :max-lines="2">{{ item.name }}</VClamp>
        </p>
        <div class="interactionsContainer">
          <p v-if="item.contributions_count > 0" class="caption2 neutral6-color" v-margin="0">
            {{ contributionText(item.contributions_count, item.contribution_type) }}
          </p>
          <p v-if="item.endorses_count > 0" class="caption2 neutral6-color" v-margin="0">{{ endorsementText(item.endorses_count) }}</p>
        </div>
      </span>
      <span v-if="item.image" class="imageContainer">
        <CpShowImageInCard :image="item.image" />
      </span>
      <div v-if="index < campaigns.length - 1" class="separator"></div>
    </a>
    <span class="buttonContainer">
      <h4>Considering running for Office?</h4>
      <CpButton @click.prevent="navigateTo('/campaigns/learn')" :loading="false" thin primary>Get Started</CpButton>
    </span>
  </div>
</template>

<style scoped>
.imageContainer {
  margin-bottom: 16px;
}
.separator {
  width: 50%;
  margin: 4px 0;
  height: 1px;
  background-color: var(--neutral3);
}
.featuredItemContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  margin: 4px 0;
  cursor: pointer;
}

.featuredImage {
  background: var(--primary1);
  margin-right: 10px;
}

.position-image {
  border: 1px var(--primary2) solid;
  border-radius: unset;
}

.position-image img {
  height: 40px;
  object-fit: cover;
}

.textContainer {
  width: 100%;
}

.interactionsContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.buttonContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #d2e0f44d;
  padding: 16px;
  margin: 8px;
  border-radius: 8px;
}

.buttonContainer h4 {
  text-align: center;
  width: 75%;
}

@media screen and (max-width: 1000px) {
  .interactionsContainer {
    flex-direction: column;
    align-items: flex-start;
  }
}
@media screen and (max-width: 768px) {
  .imageContainer {
    width: 75%;
  }
}
</style>
